<template>
    <b-container>
        <b-tabs>
            <b-tab title="Users" active>
                <users-management-tab
                    :user="user"
                    :team="team">
                </users-management-tab>
            </b-tab>
            <b-tab
                title="Teams"
                :disabled="!hasTeamsAccess">
                <multiple-team-management-tab
                    :user="user"
                    :team="team">
                </multiple-team-management-tab>
            </b-tab>
            <b-tab title="Permission Sets">
                <permission-sets-tab
                    :team="team">
                </permission-sets-tab>
            </b-tab>
        </b-tabs>
    </b-container>
</template>

<script>
import UsersManagementTab from "./team-member-management-tabs/users-management-tab.vue";
import PermissionSetsTab from "./team-member-management-tabs/permission-sets-tab.vue";
import MultipleTeamManagementTab from "./team-member-management-tabs/multiple-team-management-tab.vue";

export default {
    name: 'team-member-management',
    components: {MultipleTeamManagementTab, PermissionSetsTab, UsersManagementTab},
    props: ['user', 'team', 'hasGlobalAccess'],
    computed: {
        hasTeamsAccess() {
            return this.team.plan_id == 3 && this.hasGlobalAccess;
        }
    }
}
</script>

<style scoped>

</style>
